import { Icon } from '../Icon';
import { useIncomeSources } from '../../../IncomeSource';
import { AdjustedAnnualSpendingToggleModal } from './AdjustedAnnualSpendingToggleModal';
import { ClickAnchor } from '../ClickMenu';
import { Placement } from '@popperjs/core';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

export type AdjustedAnnualSpendingToggleProps = {
  householdID: string;
  placement?: Placement;
  offset?: [number, number];
  className?: string;
};

export const AdjustedAnnualSpendingToggle = ({
  householdID,
  placement,
  offset,
  className,
}: AdjustedAnnualSpendingToggleProps) => {
  const { incomeSources } = useIncomeSources({ householdID });
  const { t: tUI } = useTranslation('UI');
  const guaranteedIncomeSources = incomeSources.filter((income) => income.isFutureGuaranteedIncome);
  const futureIncomeEnabled =
    guaranteedIncomeSources.filter((incomeSources) => !incomeSources.omitFromScorecard).length > 0;

  if (guaranteedIncomeSources.length > 0) {
    return (
      <div className={clsx('justify-items-start items-center w-fit flex-row flex', className)}>
        <div className="text-darkMode-gray-light pr-1">{tUI('guaranteed-income-toggle-title')}</div>
        <ClickAnchor
          offset={offset}
          placement={placement || 'auto'}
          popperJSPreventOverflowOptions={{ padding: 16 }}
          floatingElement={<AdjustedAnnualSpendingToggleModal householdID={householdID} />}
        >
          {futureIncomeEnabled ? (
            <div className="flex flex-row">
              <div className="text-palette-600 font-extrabold">{tUI('ON')}</div>
              <Icon className="text-palette-600" icon="arrowDropdown" />
            </div>
          ) : (
            <div className="flex flex-row">
              <div className="text-white font-extrabold">{tUI('OFF')}</div>
              <Icon className="text-white" icon="arrowDropdown" />
            </div>
          )}
        </ClickAnchor>
      </div>
    );
  }
  return <></>;
};
